import React, { Component } from 'react';
import PropTypes from 'prop-types';
import copy from '../utils/CopyToClipoard';
import { tr } from '../utils/locale';
import Button from '../Button/Button';

export default class CopyClipboardButton extends Component {
    constructor(props) {
        super(props);
        this.state = { copied: false };
    }

    componentWillUnmount() {
        if (this.copyTimeout) {
            clearTimeout(this.copyTimeout);
        }
    }

    copy = (e) => {
        const { text, getText, copyCallback, stopPropagation } = this.props;
        const { copied } = this.state;

        if (stopPropagation) e.stopPropagation();

        const textToCopy = text || (getText ? getText() : null);

        if (textToCopy !== null && copy(textToCopy) && !copied) {
            this.setState({ copied: true }, copyCallback);
            this.copyTimeout = setTimeout(() => this.setState({ copied: false }), 1000);
        }
    };

    render() {
        const {
            type,
            noLabel,
            label: propsLabel,
            copiedLabel,
            copiedIcon,
            icon,
            getText,
            testId,
            copyCallback,
            stopPropagation,
            ...rest
        } = this.props;
        const { copied } = this.state;
        let label;
        if (noLabel) label = '';
        else label = copied && copiedLabel ? copiedLabel : propsLabel;
        return (
            <Button
                type={type}
                label={label}
                icon={copied && copiedIcon ? copiedIcon : icon}
                onClick={this.copy}
                {...rest}
                testId={testId}
            />
        );
    }
}

CopyClipboardButton.defaultProps = {
    type: 'transparent',
    label: tr('Copy'),
    noLabel: false,
    copiedLabel: tr('Copied!'),
    copiedIcon: 'check',
    icon: 'copy',
    text: null,
    getText: null,
    testId: 'copy-clipboard-button',
    copyCallback: () => {},
    stopPropagation: false,
};

CopyClipboardButton.propTypes = {
    text: PropTypes.string,
    testId: PropTypes.string,
    getText: PropTypes.func,
    type: PropTypes.string,
    label: PropTypes.string,
    noLabel: PropTypes.bool,
    copiedLabel: PropTypes.string,
    copiedIcon: PropTypes.string,
    icon: PropTypes.string,
    copyCallback: PropTypes.func,
    stopPropagation: PropTypes.bool,
};
